import { gql } from '@apollo/client'

export const GET_DATA_AREAS = gql`
  query getAreas($source: String!) {
    areas: getDataAreas(source: $source)
  }
`
